import { z } from 'zod';

// Legacy risk form schema (non-ladder fields). Ladder (tp_targets) validated separately via JSON Schema/AJV path.
export const riskSchema = z.object({
  risk_pct: z.number().min(0).max(100),
  sl: z.union([
    z.object({ type: z.literal('atr'), mult: z.number().min(0) }),
    z.object({ type: z.literal('pct'), value: z.number().min(0).max(100) }),
  ]),
  tp: z.object({
    type: z.literal('r_multiple'),
    r: z.number().min(0),
  }),
  default_rr: z.number().min(0),
  max_open_positions: z.number().int().min(1),
  daily_loss_pct: z.number().min(0).max(100),
  cooldown_minutes: z.number().int().min(0),
  // Newly exposed optional fields in UI
  consecutive_loss_limit: z.number().int().min(0).optional(),
  max_trade_risk: z.number().min(0).optional(),
  max_lot_size: z.number().min(0).optional(),
});
